import {useCallback, useEffect, useRef, useState} from "react";
import axiosInstance from "../../config/axios-config";

export default function useOverviewCount(tenantId, language, status = "products") {
    const key = `${tenantId}:${language}:${status}`;
    const request = useRef(null);
    const [result, setResult] = useState({});
    const reload = useCallback(async () => {
        request.current?.abort();
        const controller = new AbortController();
        request.current = controller;
        const current = () => request.current === controller && !controller.signal.aborted;
        if (!tenantId) {setResult({key, status: "unavailable"}); return;}
        setResult({key, status: "loading"});
        try {
            const {data} = await axiosInstance.get(status === "products" ? "/api/v1/product_tenants/current" : "/api/v1/orders/importer", {
                params: {page: 0, size: 1, ...(status === "products" ? {} : {status})},
                headers: {"Language-Context": (language || "en").toUpperCase()}, signal: controller.signal, timeout: 10000,
            });
            // Only server pagination totals establish a whole-result count; never count the page's rows.
            const count = data?.totalElements;
            if (current()) setResult(Number.isSafeInteger(count) && count >= 0
                ? {key, status: "success", count, checkedAt: new Date()} : {key, status: "unavailable"});
        } catch {
            if (current()) setResult({key, status: "error"});
        }
    }, [key, tenantId, language, status]);
    useEffect(() => {reload(); return () => request.current?.abort();}, [reload]);
    return {...(result.key === key ? result : {status: tenantId ? "loading" : "unavailable"}), reload};
}
